import axios from 'axios';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DesignDeleteModal = ({ handleClose, showDeleteModal, selectedRowId }) => {
    const handleSubmit = async () => {
        try {
          const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/orthodontic-design/${selectedRowId}`);

          handleClose();
        } catch (error) {
          console.error("Error deleting item:", error); // See if it’s a network, 404, or other error
        }
      };
  return (
    <Modal show={showDeleteModal} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete?</p>
        <input
          type="hidden"
          id="modalDescription"
          className="form-control"
          name="name"
          value={selectedRowId}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          style={{
            backgroundColor: '#c62828',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '10px 15px',
            fontSize: '16px',
            marginLeft: '10px',
          }}
          onClick={handleSubmit}
        >
          Delete
        </button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesignDeleteModal;
